<template>
  <div :style="cssVars" v-if="selectedOutcome">
    <page-layout :headerBackgroundColor="cssVars['--outcome-primary']">
      <template v-slot:headerContent>
        <div class="row">
          <span
            :style="`color: ${cssVars['--outcome-secondary']}`"
            class="title"
          >
            {{
              currentUserData.sustainabilityBusiness_name
                ? currentUserData.sustainabilityBusiness_name
                : "Test Business"
            }}
          </span>
        </div>
        <div class="row justify-between item-center">
          <div class="row items-center q-mt-sm">
            <span class="dropdownTitle text-white">
              Goals & Solutions Summary for
            </span>
            <div class="q-ml-sm">
              <sustainability-dropdown
                :model="selectedOutcome"
                class="q-ml-sm"
                :style="`width: 230px;
                      background-color: rgba(0,0, 0, 0.3);
                      border-radius: 5px;
                      `"
                :options="outcomesList"
                :isObjects="true"
                objectKey="label"
                @input="selectOutcome"
              ></sustainability-dropdown>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:content>
        <div class="row tertiaryBg">
          <div
            style="width: 30%; height: calc(100vh - 169px)"
            class="goalsSidebar"
          >
            <div class="row justify-center" style="height: calc(100vh - 220px)">
              <div class="q-mt-lg">
                <div class="row q-mb-lg">
                  <div class="yourGoalsTitle text-white">Your Goals</div>
                </div>
                <div
                  class="row q-mb-sm"
                  :class="{
                    goalCardSelected: selectedGoal
                      ? selectedGoal.id == goal.id
                      : false,
                  }"
                  v-for="(goal, i) in goals"
                  :key="i"
                  @click="selectGoal(goal)"
                >
                  <div class="goalCard q-pa-sm cursor-pointer">
                    <div
                      v-if="goal.basicGoals_id"
                      class="basicGoalText text-white"
                    >
                      {{ formatPreWrittenGoalText(goal).normalText }}
                      <span class="text-bold">
                        {{ formatPreWrittenGoalText(goal).coloredText }}
                      </span>
                    </div>
                    <div
                      v-else-if="!goal.writeYourOwnGoal"
                      class="basicGoalText text-white"
                    >
                      <div>
                        {{ goal.action == "Reduce" ? "Reduction" : "Increase" }}
                        of
                        <span class="goalItem_source_text text-bold">
                          {{ goal.sourceData.name }}
                        </span>
                        by
                        <span class="text-bold">
                          {{
                            (goal.sourceData.total * goal.reductionPercentage) /
                            100
                          }}
                          {{ goal.sourceData.unit }}
                        </span>
                        ({{ goal.action }} {{ goal.reductionPercentage }}% by
                        {{ goal.due_at.split("-")[0] }})
                      </div>
                    </div>
                    <div
                      v-else-if="goal.writeYourOwnGoal"
                      class="writeYourOwnGoalText text-white"
                    >
                      {{ goal.writeYourOwnGoal }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row q-px-md">
              <q-btn class="btnAlt" no-caps @click="() => {}">
                Go Back to Editor
              </q-btn>
            </div>
          </div>
          <div style="width: 70%">
            <div class="row" style="padding-left: 28px">
              <div>
                <div class="row solutionHeadingTitle q-pa-md">
                  Your Solutions for this Goal
                </div>
              </div>
            </div>

            <div class="row justify-center">
              <div>
                <div
                  @click="selectSolution(solution)"
                  class="row solutionItem items-center justify-center"
                  :class="{
                    solutionItemSelected: selectedSolution
                      ? selectedSolution.solutions_id == solution.solutions_id
                      : false,
                  }"
                  v-for="(solution, i) in businessSolutionsList"
                  :key="i"
                >
                  <div class="solutionItem__text" style="width: 500px">
                    {{ solution.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:sideBarContent>
        <div
          class="actionHeadingTitle"
          style="margin-top: 50px; margin-left: 20px; margin-bottom: 50px"
        >
          Your Actions
        </div>
        <div>
          <q-scroll-area
            style="width: 100%; height: calc(100vh - 250px)"
            :thumb-style="{
              background: '#162c479c',
              opacity: 1,
              width: '8px',
              height: '8px',
              borderRadius: '20px',
            }"
          >
            <div
              v-for="(action, i) in actions"
              :key="i"
              class="actionItem q-mb-md"
              style="width: 199px; margin-left: 20px"
            >
              <div class="text-bold">Action {{ action.id }}</div>
              {{ action.value }}
            </div>
          </q-scroll-area>
          <div class="row justify-end q-px-md">
            <q-btn no-caps class="btn"> View Full Plan </q-btn>
          </div>
        </div>
      </template>
    </page-layout>
  </div>
</template>

<script>
  import PageLayout from "@/components/pageLayout/pageLayout.vue";
  import SustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";
  import { mapGetters } from "vuex";
  export default {
    components: {
      PageLayout,
      SustainabilityDropdown,
    },
    watch: {
      $route: {
        handler() {
          this.handleRoute();
        },
        deep: true,
      },
    },
    data: () => ({
      selectedOutcome: null,
      selectedSolution: null,
    }),
    mounted() {
      this.init();
    },
    computed: {
      ...mapGetters({
        currentUserData: "auth/currentUserData",
        outcomesList: "outcomes/list",
        goals: "goals/list",
        selectedGoal: "goals/selectedGoal",
        businessSolutionsList: "solutions/business/list",
        actions: "solutions/business/actions/list",
      }),
      cssVars() {
        let primaryColorFaded = this.selectedOutcome.primaryColor
          ? this.selectedOutcome.primaryColor.split("#")
          : ["", "162c47"];
        let primaryColorFadedString = "#" + primaryColorFaded[1] + "80";

        return {
          "--outcome-primary": this.selectedOutcome.primaryColor
            ? this.selectedOutcome.primaryColor
            : "#162c47",
          "--outcome-secondary": this.selectedOutcome.secondaryColor
            ? this.selectedOutcome.secondaryColor
            : "#162c47",
          "--outcome-tertiary": this.selectedOutcome.tertiaryColor
            ? this.selectedOutcome.tertiaryColor
            : "#162c47",
          "--outcome-primary-faded": primaryColorFadedString,
        };
      },
    },
    methods: {
      selectSolution(solution) {
        this.selectedSolution = solution;

        this.$store.dispatch(
          "solutions/business/actions/loadAllBySolutionId",
          solution.solutions_id
        );
      },
      handleRoute() {
        if (this.$route.params.hasOwnProperty("goalsID")) {
          this.$store
            .dispatch("goals/loadByID", this.$route.params.goalsID)
            .then(() => {
              if (this.selectedGoal.sources_id) {
                this.initSolutionsBySourceID(this.selectedGoal.sources_id);
              }
            });
        } else if (this.$route.params.hasOwnProperty("outcomesID")) {
          this.init();
        }
      },
      selectOutcome(outcome) {
        this.selectedOutcome = outcome;
        this.$router.push("/solutionsGoalsSummary/" + outcome.id);
      },
      initSolutionsBySourceID(sourceID) {
        this.$store.dispatch("solutions/business/loadBySourceID", sourceID);
      },
      formatPreWrittenGoalText(goal) {
        if (goal.basicGoalAction) {
          let normalText = goal.basicGoalAction.split(goal.basicGoal);

          if (normalText.length > 0) {
            let coloredText = goal.basicGoalAction.split(normalText[0]);
            return {
              normalText: normalText[0],
              coloredText: coloredText[1],
            };
          }
        } else {
          return {
            normalText: goal.basicGoal,
            coloredText: "",
          };
        }
        let normalText = goal.basicGoalAction.split(goal.basicGoal);

        if (normalText.length > 0) {
          let coloredText = goal.basicGoalAction.split(normalText[0]);
          return {
            normalText: normalText[0],
            coloredText: coloredText[1],
          };
        }
      },
      init() {
        this.$store.dispatch("outcomes/loadAll").then((e) => {
          if (this.outcomesList.length > 0) {
            if (this.$route.params.hasOwnProperty("outcomesID")) {
              let index = this.outcomesList.findIndex(
                (o) => this.$route.params.outcomesID == o.id
              );
              this.selectedOutcome = this.outcomesList[index];
            } else {
              this.selectedOutcome = this.outcomesList[0];
            }

            this.$store.dispatch(
              "goals/loadAllGoalsAndBasicGoalsByOutcomeID",
              this.selectedOutcome.id
            );

            if (this.$route.params.hasOwnProperty("goalsID")) {
              this.$store
                .dispatch("goals/loadByID", this.$route.params.goalsID)
                .then(() => {
                  if (this.selectedGoal.sources_id) {
                    this.initSolutionsBySourceID(this.selectedGoal.sources_id);
                  }
                });
            }
          }
        });
      },
      initGoals() {
        this.formattedGoals = [];
        this.$store.dispatch(
          "goals/loadAllGoalsAndBasicGoalsByOutcomeID",
          this.selectedOutcome.id
        );
      },
      selectGoal(goal) {
        let isSameGoal = false;
        this.selectedSolution = null;
        this.$store.commit("solutions/business/actions/setList", []);
        if (this.selectedGoal && goal.id == this.selectedGoal.id) {
          isSameGoal = true;
        }
        if (this.$route.params.hasOwnProperty("goalsID")) {
          if (!isSameGoal) {
            this.$router.push(
              "/solutionsGoalsSummary/" +
                this.selectedOutcome.id +
                "/goals/" +
                goal.id
            );
          }
        } else {
          this.$router.push(this.selectedOutcome.id + "/goals/" + goal.id);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
  }

  .dropdownTitle {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
  }

  .yourGoalsTitle {
    font-family: "Montserrat";
    width: 238px;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
  }

  .goalsSidebar {
    background-color: var(--outcome-secondary);
  }

  .goalCard {
    min-height: 48px;
    width: 238px;
    background-color: var(--outcome-primary-faded);
    border-radius: 5px;
  }

  .goalCardSelected {
    background-color: var(--outcome-primary);
  }

  .writeYourOwnGoalText {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
  }

  .basicGoalText {
    font-family: "Montserrat";
    font-style: normal;
    font-size: 13px;
  }

  .solutionHeadingTitle {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    color: var(--outcome-secondary);
  }

  .solutionItem {
    background-color: white;
    color: var(--outcome-secondary);
    border-radius: 5px;
    width: 618px;
    min-height: 44px;
  }

  .solutionItemSelected {
    background-color: var(--outcome-secondary);
    color: white;
    border-radius: 5px;
    width: 618px;
    min-height: 44px;
  }

  .solutionItem__text {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 11.3746px;
  }

  .tertiaryBg {
    background-color: var(--outcome-tertiary);
  }

  .actionHeadingTitle {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    color: var(--outcome-secondary);
  }

  .actionItem {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    color: var(--outcome-secondary);
  }

  .btn {
    background-color: var(--outcome-secondary);
    color: white;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 11.39px;
  }

  .btnAlt {
    background-color: var(--outcome-primary);
    color: white;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 11.39px;
  }
</style>
